module.exports = __webpack_public_path__ + "img/mask-3.ecef3809.svg";